import { makeHook } from "../../utils/makeSingleArgHook";
import getAdvisorMarketplaceOfferingV2, { advisorMarketplaceOfferingUrl, } from "../requests/getAdvisorMarketplaceOfferingV2";
const useAdvisorMarketplaceOfferingV2 = makeHook(getAdvisorMarketplaceOfferingV2, (offeringId) => [
    advisorMarketplaceOfferingUrl(offeringId),
]);
export default useAdvisorMarketplaceOfferingV2;
//# sourceMappingURL=useAdvisorMarketplaceOfferingV2.js.map